import React from 'react';
import './Service.css';

const services = [
  {
    title: 'Classes',
    description: 'Join our cardio sessions to lose weight and stay fit.',
    videoUrl: 'https://www.facebook.com/plugins/video.php?height=316&href=https%3A%2F%2Fwww.facebook.com%2Fspartans.official%2Fvideos%2F7325689557491190%2F&show_text=false&width=560&t=0',
  },
  {
    title: 'Gym',
    description: 'Engage in weight training with our state-of-the-art equipment.',
    videoUrl: 'https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Fspartans.official%2Fvideos%2F990478746054233%2F&show_text=true&width=269&t=0',
  },
  {
    title: 'Swimming Pool',
    description: 'Open from April to October, enjoy our Olympic-sized pool.',
    videoUrl: 'https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Fspartans.official%2Fvideos%2F628805872540336%2F&show_text=true&width=267&t=0',
  },
];

const Service = () => {
  return (
    <div className="service-container">
      <h2>Our Services</h2>
      <div className="services">
        {services.map((service, index) => (
          <div
            className={`service-card ${service.title === 'Classes' ? 'classes-service' : ''}`}
            key={index}
          >
            {service.videoUrl ? (
              <iframe
                title={service.title}
                src={service.videoUrl}
                width="560"
                height="316"
                style={{ border: 'none', overflow: 'hidden' }}
                scrolling="no"
                frameBorder="0"
                allowFullScreen={true}
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              ></iframe>
            ) : (
              <img src={service.imageUrl} alt={service.title} className="service-image" />
            )}
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Service;
